import script from "./Card.vue?vue&type=script&setup=true&lang=js"
export * from "./Card.vue?vue&type=script&setup=true&lang=js"

import "./Card.vue?vue&type=style&index=0&id=64d51ce3&scoped=true&lang=css"

import exportComponent from "/data/gitlab-runner/builds/hunterretail/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d51ce3"]])

export default __exports__